import { Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { useSelector } from "react-redux";
import { CustomItemTooltip } from "../../../../../ResuableChartTooltip/CustomItemTooltip";

const DailyLandingPageExperience = () => {
  const { dailyLPExperienceDetails } = useSelector(
    (state: any) => state.landingPageExperience
  );

  const Y_MIN = 0;
  const Y_MAX = 3; // or compute from your data
  const integerTicks = Array.from(
    { length: Y_MAX - Y_MIN + 1 },
    (_, i) => i + Y_MIN
  );

  const sortedDetails =
    dailyLPExperienceDetails
      ?.slice() // copy to avoid mutating Redux state
      .sort(
        (a: any, b: any) =>
          new Date(a.date).getTime() - new Date(b.date).getTime()
      ) || [];

  // Extract values dynamically
  const costData =
    sortedDetails?.map((item: any) => item.lp_exp_score_weight) || [];

  const month =
    sortedDetails?.map((item: any) => {
      const d = new Date(item.date);
      return d.toLocaleDateString("en-GB"); // dd/mm/yyyy
    }) || [];

  return (
    <>
      <Typography fontSize={24} mb={2}>
        Daily LP Experience
      </Typography>

      <BarChart
        height={300}
        margin={{ top: 20, right: 30, bottom: 40, left: 30 }} // more breathing room
        series={[
          {
            data: costData,
            yAxisId: "rightAxis",
            color: "#8133F1",
          },
        ]}
        leftAxis={null}
        rightAxis={{}}
        xAxis={[
          {
            data: month,
            scaleType: "band",
            disableLine: false,
            disableTicks: true,
          },
        ]}
        grid={{ horizontal: true }}
        yAxis={[
          {
            id: "rightAxis",
            min: 1,
            max: Y_MAX,
            tickInterval: integerTicks,
            tickLabelInterval: () => true,
            valueFormatter: (v) => Number(v).toFixed(1),
          },
        ]}
        tooltip={{ trigger: "item" }} // show tooltip on hover
      >
        <CustomItemTooltip />
      </BarChart>
    </>
  );
};

export default DailyLandingPageExperience;
